import { useState, useEffect } from './wp';
import { CloseIcon, ChevronIcon, SearchIcon } from './icons';

/**
 * Mobile navigation drawer — a drill-down, matching the behaviour of the ACF
 * mobile-navigation block it replaces.
 *
 * @param {Object}   props
 * @param {boolean}  props.open
 * @param {Function} props.onClose
 * @param {Array}    props.items    nav tree
 * @param {Object}   props.config   TSA_CHROME
 * @param {Function} props.onSearch opens the search panel
 */
export default function MobileNav({ open, onClose, items, config, onSearch }) {
    const [drill, setDrill] = useState(null);

    useEffect(() => {
        if (!open) {
            setDrill(null);
        }
    }, [open]);

    const current = drill !== null ? items[drill] : null;

    return (
        <div className={'tsa-mnav' + (open ? ' is-open' : '')} aria-hidden={!open}>
            <div className="tsa-mnav__scrim" onClick={onClose} />
            <div className="tsa-mnav__panel" role="dialog" aria-modal="true" aria-label="Menu">
                <header className="tsa-mnav__head">
                    {current ? (
                        <button type="button" className="tsa-mnav__back" onClick={() => setDrill(null)}>
                            <ChevronIcon direction="left" />
                            {current.label}
                        </button>
                    ) : (
                        <span className="tsa-mnav__title">Menu</span>
                    )}
                    <button type="button" onClick={onClose} aria-label="Close menu">
                        <CloseIcon />
                    </button>
                </header>

                <button type="button" className="tsa-mnav__search" onClick={onSearch}>
                    <SearchIcon />
                    Search adventures
                </button>

                <ul className="tsa-mnav__list">
                    {current
                        ? current.children.map((child) => (
                              <li key={child.url + child.label}>
                                  <a href={child.url}>{child.label}</a>
                              </li>
                          ))
                        : items.map((item, position) =>
                              item.children && item.children.length ? (
                                  <li key={item.label}>
                                      <button type="button" onClick={() => setDrill(position)}>
                                          {item.label}
                                          <ChevronIcon direction="right" />
                                      </button>
                                  </li>
                              ) : (
                                  <li key={item.label}>
                                      <a href={item.url}>{item.label}</a>
                                  </li>
                              )
                          )}
                </ul>

                <div className="tsa-mnav__foot">
                    <a className="tsa-mnav__cta" href={config.cta.url}>
                        {config.cta.label}
                    </a>
                    {config.account.loggedIn && (
                        <a className="tsa-mnav__logout" href={config.account.logout}>
                            Log out
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}
